import { applicationModuleRegistry } from '../application-module-registry.js';
import { foundationContext } from '../context/index.js';
/**
 * This method is responsible for returning all available modules for a given user, by comparing the available modules
 * in the user profile with the modules registered for the application.
 *
 * @example
 * ```
 * const modules = getAvailableModules();
 * ```
 */
function getAvailableModules() {
    const modules = new Map();
    const profileModules = (foundationContext.getAvailableModules() || []).map((module) => module.id);
    for (const module of applicationModuleRegistry.getModules()) {
        if (module.disabled) {
            continue;
        }
        if (profileModules.includes(module.id)) {
            modules.set(module.id, module);
        }
    }
    return modules;
}
export { getAvailableModules, };
//# sourceMappingURL=available-modules.js.map